import { render, staticRenderFns } from "./LibraryPermissions.vue?vue&type=template&id=17d59a14&"
import script from "./LibraryPermissions.vue?vue&type=script&lang=js&"
export * from "./LibraryPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports